<template>
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M42.5 24C42.5 28.9065 40.5509 33.6121 37.0815 37.0815C33.6121 40.5509 28.9065 42.5 24 42.5C19.0935 42.5 14.3879 40.5509 10.9185 37.0815C7.4491 33.6121 5.5 28.9065 5.5 24C5.5 19.0935 7.4491 14.3879 10.9185 10.9185C14.3879 7.4491 19.0935 5.5 24 5.5C28.9065 5.5 33.6121 7.4491 37.0815 10.9185C40.5509 14.3879 42.5 19.0935 42.5 24Z"
            stroke="#953B9A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M22.5 13.5V25.5H30.5" stroke="#953B9A" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>